const bigbrainEvents = {
  GENERAL: {
    APP_INIT: 'app_init',
  },
  HEADER: {
    PREVIEW_CLICKED: 'preview_clicked',
    DOWNLOAD_CLICKED: 'download_clicked',
    SEND_CLICKED: 'send_clicked',
  },
  SHARE: {
    SHARE_MODAL_FAILED: 'share_modal_failed',
  },
  MONDAY_BRAND: {
    MONDAY_BRAND_CHANGE: 'monday_brand_change',
    UPGRADE_BUTTON_CLICK: 'upgrade_button_click',
  },
  ADJUSTMENTS: {
    ADD_NEW: 'add_new_adjustment',
  },
  COMPONENT_ERROR: 'component_error',
};

export default bigbrainEvents;
